// ─── Layout UI string constants ───────────────────────────────────────────────

import React from 'react';

import {
  LuRepeat,
  LuLayoutDashboard,
  LuClipboardList,
  LuReceipt,
  LuRefrigerator,
  LuStore,
  LuSmartphone,
  LuPackage,
  LuBarChart3,
  LuServer,
  LuUserCog,
  LuTimer,
  LuBell,
  LuSettings,
  LuRefreshCcw,
  LuRepeat2,
  LuCreditCard,
  LuUsers,
  LuUser,
  LuScrollText,
  LuBoxes,
} from 'react-icons/lu';

export const SIDEBAR_PROPS = {
  SECTIONS: {
    OVERVIEW: 'Overview',
    VDI_MANAGEMENT: 'VDI Management',
    SMART_COOLERS: 'SmartCoolers',
    INVENTORY: 'Inventory',
    ADMIN_PANEL: 'Admin Panel',
  },
  HOVER_EXPAND_LOCK_TITLE: 'Hover Expand Lock',
  HOVER_EXPAND_LOCK_ENABLED: 'Enabled: fixed expanded',
  HOVER_EXPAND_LOCK_DISABLED: 'Disabled: hover expand',
  COLLAPSE_LABEL: 'Collapse sidebar',
  EXPAND_LABEL: 'Expand sidebar',
  TOGGLE_ARIA_LABEL: 'Toggle sidebar hover expand lock',
};

export const HEADER_PROPS = {
  LOGOUT: 'Logout',
  NOTIFICATION_TITLE: 'Notification',
  PROFILE_TITLE: 'Profile',
  THEME_LIGHT: 'Light',
  THEME_DARK: 'Dark',
  THEME_SYSTEM: 'System',
};

export const FOOTER_PROPS = {
  COMPANY_NAME: 'Cantaloupe',
  COMPANY_URL: 'https://www.cantaloupe.com/',
  ALL_RIGHTS_RESERVED: 'All Rights Reserved.',
};

export const BREADCRUMB_PROPS = {
  HOME_LABEL: 'Home',
  HOME_NAVIGATE_PATH: '/dashboard',
};

export const NAV_ITEMS = {
  DASHBOARD: 'dashboard',
  VDI_TRANSACTIONS: 'VDI transactions',
  SMART_COOLER_PRODUCTS: 'smart cooler products',
  COOLER_TRANSACTIONS: 'smart cooler transactions',
  MARKETS: 'markets',
  DEVICES: 'devices',
  PRODUCTS: 'products',
  SALES: 'sales',
  PROVIDERS: 'providers',
  OPERATORS: 'operators',
  RECONCILIATION: 'reconciliation',
  TARGETED_RECONCILIATION: 'targeted reconciliation',
  QUICK_PAY: 'quick pay',
  USERS: 'users',
  CRONJOBS: 'cronjobs',
  ALERTS: 'smart cooler alerts',
  APP_LOGS: 'app logs',
  SMART_COOLERS: 'smart coolers',
  PROFILE: 'profile',
  SETTINGS: 'settings',
};

export const NAV_ITEM_ICONS = {
  [NAV_ITEMS.DASHBOARD]: LuLayoutDashboard,
  [NAV_ITEMS.VDI_TRANSACTIONS]: LuRepeat,
  [NAV_ITEMS.SMART_COOLER_PRODUCTS]: LuBoxes,
  [NAV_ITEMS.COOLER_TRANSACTIONS]: LuClipboardList,
  [NAV_ITEMS.MARKETS]: LuStore,
  [NAV_ITEMS.DEVICES]: LuSmartphone,
  [NAV_ITEMS.PRODUCTS]: LuPackage,
  [NAV_ITEMS.SALES]: LuBarChart3,
  [NAV_ITEMS.PROVIDERS]: LuServer,
  [NAV_ITEMS.OPERATORS]: LuUserCog,
  [NAV_ITEMS.RECONCILIATION]: LuRefreshCcw,
  [NAV_ITEMS.TARGETED_RECONCILIATION]: LuRepeat2,
  [NAV_ITEMS.QUICK_PAY]: LuCreditCard,
  [NAV_ITEMS.USERS]: LuUsers,
  [NAV_ITEMS.CRONJOBS]: LuTimer,
  [NAV_ITEMS.ALERTS]: LuBell,
  [NAV_ITEMS.APP_LOGS]: LuScrollText,
  [NAV_ITEMS.SMART_COOLERS]: LuRefrigerator,
  [NAV_ITEMS.PROFILE]: LuUser,
  [NAV_ITEMS.SETTINGS]: LuSettings,
};

export const getNavItemIcon = (item: string, className = 'h-6 w-6') => {
  const Icon = NAV_ITEM_ICONS[item as keyof typeof NAV_ITEM_ICONS];
  return Icon ? React.createElement(Icon, { className }) : null;
};

export const BREADCRUMB_LABELS = {
  DASHBOARD: 'Dashboard',
  VDI_TRANSACTIONS: 'VDI Transactions',
  SMART_COOLER_PRODUCTS: 'Smart Cooler Products',
  COOLER_TRANSACTIONS: 'Smart Cooler Transactions',
  MARKETS: 'Markets',
  DEVICES: 'Devices',
  PRODUCTS: 'Products',
  SALES: 'Sales',
  PROVIDERS: 'Providers',
  CREATE_PROVIDER: 'Create Provider',
  EDIT_PROVIDER: 'Edit Provider',
  VIEW_PROVIDER: 'View Provider',
  PROVIDER_DETAILS: 'Provider Details',
  OPERATORS: 'Operators',
  VIEW_OPERATOR: 'View Operator',
  CRON_JOBS: 'Cron Jobs',
  ALERTS: 'Smart Cooler Alerts',
  APP_LOGS: 'Application Logs',
  SMART_COOLERS: 'Smart Coolers',
  SMART_COOLER_DETAILS: 'Smart Cooler Details',
  PROFILE: 'Profile',
  SETTINGS: 'Settings',
};
